import {
  addToJobModalSchema,
  ADD_TO_JOB_INITIAL_VALUES,
  addCandidateToJob,
  addToAnotherJob,
  Button,
  ComponentStyle,
  closeModalUsingState,
  Form,
  Formik,
  FormikControl,
  getCandidateActiveJobList,
  handleSelectJobValueOnChange,
  InputError,
  useEffect,
  useState,
  useSWR,
  FormStyle,
  InputText,
  useTranslation
} from "@/imports-files/components/add-to-job-modal.js";
import { FormModalStyle } from "@/imports-files/components/review-email";
import Modal from "./common-modal/modal";

export function AddToJobModal(props) {
  const {t} =useTranslation()
  const { data, error } = useSWR("candidate_active_jobs", () => {
    return getCandidateActiveJobList({ current_job_id: props.job_id || "" });
  });
  const [selectJobId, setSelectJobId] = useState("");
  const [isLoading, setLoading] = useState(true);
  const ADD_TO_JOB_MODAL_SCHEMA = addToJobModalSchema(t);

  useEffect(() => {
    if (data) {
      setLoading(false);
    }
  }, [data]);

  if (isLoading) {
    return "";
  }

  return (
    <Modal
      type="form"
      heading={t('modal:form:add_job:heading')}
      closeModal={() => {
        closeModalUsingState(false, props.setCandidateAddToJobModal);
      }}
      content={
        <Formik
          initialValues={ADD_TO_JOB_INITIAL_VALUES}
          validationSchema={ADD_TO_JOB_MODAL_SCHEMA}
          onSubmit={() => {
            if (
              props.from &&
              (props.from == "kanban" || props.from == "application_view")
            ) {
              addToAnotherJob(
                props.job_id,
                selectJobId,
                props.params,
                props.router,
                props.setCandidateAddToJobModal,
                props.setAutomationActions,
                props.setAutomationBar,
                props.restart,
                props.setTimerStatus,
                props.from,
                props.setSelectedCards,
                props.activeTab,
                props.setActionBar
              );
            } else {
              addCandidateToJob(
                selectJobId,
                props.selectedCandidateId,
                props.setCandidateAddToJobModal,
                props.setCandidateBulkActionModal,
                props.from
              );
            }
          }}
        >
          {(formik) => (
            <Form>
              <div
                className={
                  `${FormModalStyle.Modal__Container__ContentSection__Block} ${FormStyle.Form__TableCol} mt30`
                }
              >
                <label className={`${FormStyle.Form__FloatingLabel}`} style={InputText(formik, "select_job")}>
                  <span className={`red-color`}>*</span>&nbsp;{t('label:select:job')}
                </label>
                <FormikControl
                  control="select"
                  formik={formik}
                  name="select_job"
                  onChange={(value) =>
                    handleSelectJobValueOnChange(value, setSelectJobId, formik)
                  }
                  options={data}
                  className={FormModalStyle.CustomSelect}
                  style={InputError(formik, "select_job")}
                  default={data.job_type}
                />
              </div>
              <div className="height113"/>
              <div className={FormModalStyle.Modal__Container__ButtonSection}>
                <Button
                  buttonstyle={FormModalStyle.secondarybtn}
                  onClick={() => {
                    closeModalUsingState(
                      false,
                      props.setCandidateAddToJobModal
                    );
                  }}
                >
                 {t('button:cancel')}
                </Button>
                <Button buttonstyle={FormModalStyle.primarybtn} type="submit">
                {t('button:save')}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      }
    />
  );
}
